/* import __COLOCATED_TEMPLATE__ from './objective-list-item.hbs.js'; */
import { buildTask as _buildTask } from "ember-concurrency/async-arrow-runtime";
var _dec, _dec2, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { cached, tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { dropTask, restartableTask, timeout } from 'ember-concurrency';
import { service } from '@ember/service';
import { validatable, Length, HtmlNotBlank } from 'ilios-common/decorators/validation';
import { TrackedAsyncData } from 'ember-async-data';
let SessionObjectiveListItemComponent = (_dec = Length(3, 65000), _dec2 = HtmlNotBlank(), validatable(_class = (_class2 = class SessionObjectiveListItemComponent extends Component {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "store", _descriptor, this);
    _initializerDefineProperty(this, "title", _descriptor2, this);
    _initializerDefineProperty(this, "isManagingParents", _descriptor3, this);
    _initializerDefineProperty(this, "parentsBuffer", _descriptor4, this);
    _initializerDefineProperty(this, "isManagingDescriptors", _descriptor5, this);
    _initializerDefineProperty(this, "descriptorsBuffer", _descriptor6, this);
    _initializerDefineProperty(this, "isManagingTerms", _descriptor7, this);
    _initializerDefineProperty(this, "termsBuffer", _descriptor8, this);
    _initializerDefineProperty(this, "selectedVocabulary", _descriptor9, this);
    _initializerDefineProperty(this, "fadeTextExpanded", _descriptor10, this);
    _defineProperty(this, "saveTitleChanges", _buildTask(() => ({
      context: this,
      generator: function* () {
        this.addErrorDisplayFor('title');
        const isValid = yield this.isValid('title');
        if (!isValid) {
          return false;
        }
        this.removeErrorDisplayFor('title');
        this.args.sessionObjective.set('title', this.title);
        yield this.args.sessionObjective.save();
      }
    }), null, "saveTitleChanges", "drop"));
    _defineProperty(this, "manageParents", _buildTask(() => ({
      context: this,
      generator: function* () {
        this.parentsBuffer = yield this.args.sessionObjective.courseObjectives;
        this.isManagingParents = true;
      }
    }), null, "manageParents", "drop"));
    _defineProperty(this, "manageDescriptors", _buildTask(() => ({
      context: this,
      generator: function* () {
        this.descriptorsBuffer = yield this.args.sessionObjective.meshDescriptors;
        this.isManagingDescriptors = true;
      }
    }), null, "manageDescriptors", "drop"));
    _defineProperty(this, "manageTerms", _buildTask(() => ({
      context: this,
      generator: function* (vocabulary) {
        this.selectedVocabulary = vocabulary;
        this.termsBuffer = yield this.args.sessionObjective.terms;
        this.isManagingTerms = true;
      }
    }), null, "manageTerms", "drop"));
    _defineProperty(this, "highlightSave", _buildTask(() => ({
      context: this,
      generator: function* () {
        yield timeout(1000);
      }
    }), null, "highlightSave", "restartable"));
    _defineProperty(this, "saveParents", _buildTask(() => ({
      context: this,
      generator: function* () {
        const newParents = this.parentsBuffer.map(obj => {
          return this.store.peekRecord('course-objective', obj.id);
        });
        this.args.sessionObjective.set('courseObjectives', newParents);
        yield this.args.sessionObjective.save();
        this.parentsBuffer = [];
        this.isManagingParents = false;
        this.highlightSave.perform();
      }
    }), null, "saveParents", "drop"));
    _defineProperty(this, "saveDescriptors", _buildTask(() => ({
      context: this,
      generator: function* () {
        this.args.sessionObjective.set('meshDescriptors', this.descriptorsBuffer);
        yield this.args.sessionObjective.save();
        this.descriptorsBuffer = [];
        this.isManagingDescriptors = false;
        this.highlightSave.perform();
      }
    }), null, "saveDescriptors", "drop"));
    _defineProperty(this, "saveTerms", _buildTask(() => ({
      context: this,
      generator: function* () {
        this.args.sessionObjective.set('terms', this.termsBuffer);
        yield this.args.sessionObjective.save();
        this.termsBuffer = [];
        this.isManagingTerms = false;
        this.highlightSave.perform();
      }
    }), null, "saveTerms", "drop"));
    _defineProperty(this, "deleteObjective", _buildTask(() => ({
      context: this,
      generator: function* () {
        yield this.args.sessionObjective.destroyRecord();
      }
    }), null, "deleteObjective", "drop"));
    this.title = this.args.sessionObjective.title;
  }
  get hasErrorForTitleData() {
    return new TrackedAsyncData(this.hasErrorFor('title'));
  }
  get hasErrorForTitle() {
    return this.hasErrorForTitleData.isResolved ? this.hasErrorForTitleData.value : false;
  }
  get parentsData() {
    return new TrackedAsyncData(this.args.sessionObjective.courseObjectives);
  }
  get meshDescriptorsData() {
    return new TrackedAsyncData(this.args.sessionObjective.meshDescriptors);
  }
  get parents() {
    return this.parentsData.isResolved ? this.parentsData.value : null;
  }
  get meshDescriptors() {
    return this.meshDescriptorsData.isResolved ? this.meshDescriptorsData.value : null;
  }
  get isManaging() {
    return this.isManagingParents || this.isManagingDescriptors || this.isManagingTerms;
  }
  expandAllFadeText(isExpanded) {
    this.fadeTextExpanded = isExpanded;
  }
  revertTitleChanges() {
    this.title = this.args.sessionObjective.title;
    this.removeErrorDisplayFor('title');
  }
  changeTitle(contents) {
    this.title = contents;
    this.addErrorDisplayFor('title');
  }
  addParentToBuffer(objective) {
    this.parentsBuffer = [...this.parentsBuffer, objective];
  }
  removeParentFromBuffer(objective) {
    this.parentsBuffer = this.parentsBuffer.filter(obj => obj.id !== objective.id);
  }
  addDescriptorToBuffer(descriptor) {
    this.descriptorsBuffer = [...this.descriptorsBuffer, descriptor];
  }
  removeDescriptorFromBuffer(descriptor) {
    this.descriptorsBuffer = this.descriptorsBuffer.filter(obj => obj.id !== descriptor.id);
  }
  addTermToBuffer(term) {
    this.termsBuffer = [...this.termsBuffer, term];
  }
  removeTermFromBuffer(term) {
    this.termsBuffer = this.termsBuffer.filter(obj => obj.id !== term.id);
  }
  cancel() {
    this.parentsBuffer = [];
    this.descriptorsBuffer = [];
    this.termsBuffer = [];
    this.isManagingParents = false;
    this.isManagingDescriptors = false;
    this.isManagingTerms = false;
    this.selectedVocabulary = null;
  }
}, _descriptor = _applyDecoratedDescriptor(_class2.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "title", [_dec, _dec2, tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "isManagingParents", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "parentsBuffer", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "isManagingDescriptors", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "descriptorsBuffer", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "isManagingTerms", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "termsBuffer", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "selectedVocabulary", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, "fadeTextExpanded", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class2.prototype, "hasErrorForTitleData", [cached], Object.getOwnPropertyDescriptor(_class2.prototype, "hasErrorForTitleData"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "parentsData", [cached], Object.getOwnPropertyDescriptor(_class2.prototype, "parentsData"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "meshDescriptorsData", [cached], Object.getOwnPropertyDescriptor(_class2.prototype, "meshDescriptorsData"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "expandAllFadeText", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "expandAllFadeText"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "revertTitleChanges", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "revertTitleChanges"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "changeTitle", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "changeTitle"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "addParentToBuffer", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "addParentToBuffer"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "removeParentFromBuffer", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "removeParentFromBuffer"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "addDescriptorToBuffer", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "addDescriptorToBuffer"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "removeDescriptorFromBuffer", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "removeDescriptorFromBuffer"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "addTermToBuffer", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "addTermToBuffer"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "removeTermFromBuffer", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "removeTermFromBuffer"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "cancel", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "cancel"), _class2.prototype), _class2)) || _class);
export { SessionObjectiveListItemComponent as default };